import Main from "./Main";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
